import makeDrawerState from './_makeDrawerState.js';

export const { actions, reducer } = makeDrawerState('changesDrawer');

export default reducer;
